import ko from '@tko/build.knockout';
import _ from 'lodash';
import templateMarkup from 'raw-loader!./kpi-n-trend-options.template.html';
import BaseDialog from '../../../../../components/modal-dialog/base-dialog';
import $ from 'jquery';
import Signals from 'signals';
import DataService from '../../../services/data-secure.service';
import FilterModel from '../../../components/filter/data/filter.model';
import FilterExpressionService from '../../../services/filter.expression.service';
import PanelOptionsService from '../panel-options.service';
import '../../../components/filter/filter';
import '../../../../../app/bindings/tko-bootstrap-multiselect.binding';
import MetricService from "../../../services/metric.service";

var ALL_MODELS = { id: 'all', name: 'All' };
var GROUPBY_NONE_VALUE = [];
const TREND_TYPE_DEFAULT = { value: 'simple', text: 'Simple' };
const TREND_TYPE_STACKED = { value: 'stacked', text: 'Stacked Area' };
const TREND_TYPE_PERCENT = { value: 'percentStacked', text: 'Percent Stacked Area' };
const TREND_TYPE_TO_TEXT_MAP = {};
TREND_TYPE_TO_TEXT_MAP[TREND_TYPE_DEFAULT.value] = TREND_TYPE_DEFAULT.text;
TREND_TYPE_TO_TEXT_MAP[TREND_TYPE_STACKED.value] = TREND_TYPE_STACKED.text;
TREND_TYPE_TO_TEXT_MAP[TREND_TYPE_PERCENT.value] = TREND_TYPE_PERCENT.text;
var AGGREGATE_DEFAULT_VALUE = 'latest';

var KPI_TYPE = PanelOptionsService.KPI_TYPE;
var TREND_TYPE = PanelOptionsService.TREND_TYPE;
var ALL_ANALYSIS_TYPES = [ KPI_TYPE, TREND_TYPE ];
var TRUNK_CATEGORY = 'trunk';

function KpiAndTrendOptionsDialogVM(config) {
    var self = this;
    self.initialize(config);
}

KpiAndTrendOptionsDialogVM.prototype = {
    apply: function () {
        var self = this;
        if (!this.isFormReady()) {
            return;
        }
        // set timeout to let any form inputs complete editing before closing
        setTimeout(function() {
          self.selectedOptions.aggregateFunction = self.selectedOptions.aggregateFunction || AGGREGATE_DEFAULT_VALUE;
          var params = _.assign({},
              self.selectedOptions,
              { filters: self.filterModel.getActiveFilters() }
          );
          self.modal.close({
              panel: PanelOptionsService.getPanelOptions(self.selectedOptions),
              params: params
          });
        });
    },

    close: function () {
        var self = this;
        self.modal.close();
    },

    initialize: function (config) {
        var self = this;
        self.isFirstSetup = false;
        self.subscriptions = {};
        self.metadata = _.get(config, 'metadata', {});
        self.selectedOptions = _.get(config, 'selections', {});
        // migrate metric ids
        self.selectedOptions.metricId = MetricService.getUpdatedMetricId(self.metadata, self.selectedOptions.metricId);
        self.initialAnalysisId = _.get(self.selectedOptions, 'analysisId', '');

        self.filterModel = new FilterModel();
        self.filterReadySignal = new Signals.Signal();
        self.filterDatasetName = ko.observable();

        self.setupPanelModelOptions();

        self.mustBeCalledAfterKoDecendentsComplete = self.setupConfigSelectors.bind(self);
    },

    setupPanelModelOptions: function () {
        var self = this;

        self.titleConfig = self.getTitleConfig();
        self.analysisConfig = self.getAnalysisConfig();
        self.categoryConfig = self.getCategoryConfig();
        self.modelConfig = self.getModelConfig();
        self.metricConfig = self.getMetricConfig();
        self.groupByConfig = self.getGroupByConfig();
        self.trendConfig = self.getTrendConfig();
        self.aggregationConfig = self.getAggregationConfig();
        self.filtersConfig = self.getFiltersConfig();

        self.setupComputedsAndSubscriptions();
    },

    koDescendantsComplete: function () {
        var self = this;
    },

    setupConfigSelectors: function () {
        var self = this;
        setTimeout(() => { // this is a hack due to mustBeCalledAfterKoDecendentsComplete being called EARLY! before koDescendantsComplete and koDescendantsComplete isn't called at all - it's working without it but only because of the extra DataService.fetchMetricModels call
            DataService.fetchMetricModels().then(function (models) {
                self.modelsMetaData = models;
                self.restoreSelections(self.selectedOptions);
            });
        }, 10);
    },

    getTitleConfig: function () {
        return {
            id: 'title',
            label: 'Panel Title:',
            selectedOption: ko.observable(''),
            visible: true
        };
    },

    getAnalysisConfig: function () {
        var self = this;
        return {
            id: 'analysis',
            label: 'Analysis:',
            availableOptions: ko.observableArray(getDropdownOptions(ALL_ANALYSIS_TYPES)),
            selectedOption: ko.observable(),
            nonSelectedText: '(select analysis)',
            onUpdate: function () {
                var selectedValue = ko.unwrap(self.analysisConfig.selectedOption);
                if (!_.isNil(selectedValue)) {
                    self.selectedOptions.analysisId = selectedValue;

                    if (!self.isFirstSetup) {
                        self.modelConfig.selectedOption(null);
                        self.resetPanelModelOptions();
                    }

                    var selection = _.find(
                        ko.unwrap(self.analysisConfig.availableOptions), function (option) {
                            return option.value === selectedValue;
                        }
                    );
                    self.titleConfig.selectedOption(_.get(selection, 'text', self.initialAnalysisId));

                    if (_.isNil(self.subscriptions.category)) {
                        self.subscriptions.category =
                            self.categoryConfig.selectedOption.subscribe(self.categoryConfig.onUpdate);
                    }
                }
            },
            visible: true // todo not part of template, so not actually visible
        };
    },

    getCategoryConfig: function () {
        let self = this;
        const nonSelectedText = '(select category)';
        return {
            id: 'category',
            label: 'Category:',
            availableOptions: ko.observableArray(getDropdownOptions(self.metadata)),
            selectedOption: ko.observable(),
            nonSelectedText: nonSelectedText,
            onUpdate: function () {
                var selectedValue = ko.unwrap(self.categoryConfig.selectedOption);

                if (!_.isNil(selectedValue) && selectedValue !== nonSelectedText) {
                    self.selectedOptions.categoryId = selectedValue;
                    // append 's' because category ID is singular but filter expects plural
                    // TODO: convert bridges and callcontrol (metric category) to system
                    // TODO: this works for now, but relies on an assumption about the categoryId values that may not always be true
                    self.filterDatasetName(selectedValue + (!_.endsWith(selectedValue,'s') ? 's' : ''));

                    if (!self.isFirstSetup) {
                        self.resetPanelModelOptions();
                    }

                    self.selectedCategoryMetadata = _.find(self.metadata, function (item) {
                        return item.id === selectedValue;
                    });


                    if (_.isNil(self.subscriptions.model)) {
                        self.subscriptions.model =
                            self.modelConfig.selectedOption.subscribe(self.modelConfig.onUpdate);
                    }

                    self.filterModel.setActiveFilters({ filterGroups: [{ filters:[], operator: 'and' }], operator: 'and' });
                    // the api keys are always plural so make sure we add a 's' to things
                    var modelKey = 'models.' + self.selectedOptions.categoryId;
                    if (!_.endsWith(modelKey, 's')) {
                        modelKey += 's';
                    }
                    var modelList = _.get(self.modelsMetaData, modelKey);

                    var modelMetaData = _.get(self.selectedCategoryMetadata, 'models');

                    // filter model metadata based on modelList ids
                    var filteredModelMetadata = _.filter(modelMetaData, function (o) {
                        return _.includes(modelList, o.id);
                    });

                    self.modelConfig.availableOptions(getDropdownOptions(
                        _.concat([], ALL_MODELS, filteredModelMetadata)
                    ));

                    if (!self.isFirstSetup) {
                        // clear filter and group by
                        self.filterModel.setActiveFilters({filterGroups: [{filters: [], operator: 'and'}], operator: 'and'});
                        self.groupByConfig.selectedOption(GROUPBY_NONE_VALUE);
                    }

                    var modelConfigOptions = self.modelConfig.availableOptions();
                    if (modelConfigOptions.length === 1) {
                        self.modelConfig.selectedOption(_.get(modelConfigOptions, '0.value'));
                    }
                    self.modelConfig.visible(ko.unwrap(self.modelConfig.availableOptions).length > 1);
                }
            },
            visible: true
        };
    },

    getModelConfig: function () {
        var self = this;
        const nonSelectedText = '(select model)';
        return {
            id: 'model',
            label: 'Metrics Applicable To:',
            availableOptions: ko.observableArray(null),
            selectedOption: ko.observable(),
            nonSelectedText: nonSelectedText,
            onUpdate: function () {
                var selectedValue = ko.unwrap(self.modelConfig.selectedOption),
                    selectedCategory = ko.unwrap(self.categoryConfig.selectedOption);

                if (selectedValue && selectedValue !== nonSelectedText) {
                    self.selectedOptions.modelId = selectedValue;

                    self.selectedModelMetadata = _.find(_.get(self.selectedCategoryMetadata, 'models'), function (model) {
                        return model.id === selectedValue;
                    });

                    if (_.isNil(self.selectedModelMetadata)) {
                        self.selectedModelMetadata = self.selectedCategoryMetadata;
                    }


                    var metrics = getDropdownOptions(_.get(self.selectedModelMetadata, 'metrics'));
                    self.metricConfig.availableOptions(metrics);

                    if (_.isNil(self.subscriptions.metric)) {
                        self.subscriptions.metric =
                            self.metricConfig.selectedOption.subscribe(self.metricConfig.onUpdate);
                    }

                    if (!self.isFirstSetup) {
                        if (selectedValue !== ALL_MODELS.id) {
                            if (_.get(self.selectedCategoryMetadata, 'modelFilter')) {
                                self.filterModel.setActiveFilters({
                                    filterGroups: [{
                                        filters: [{
                                            field: self.selectedCategoryMetadata.modelFilter,
                                            fieldText: "System Type",
                                            filterComplete: true,
                                            text: 'System Type in ' + selectedValue,
                                            type: 'metric',
                                            operatorText: 'in',
                                            operatorValue: '=in=(|)',
                                            isQuickPick: false,
                                            value: 'tags=in=("|=|")'.replace('|', self.selectedCategoryMetadata.modelFilter).replace('|', selectedValue),
                                            queryVar: selectedValue,
                                            auto: true
                                        }], 
                                        operator: 'and'
                                    }], 
                                    operator: 'and'
                                });
                            }
                        } else {
                            self.filterModel.setActiveFilters({filterGroups: [{filters: [], operator: 'and'}], operator: 'and'});
                        }

                        if (self.analysisConfig.selectedOption() === TREND_TYPE.id && selectedValue === ALL_MODELS.id) {
                            self.aggregationConfig.selectedOption(AGGREGATE_DEFAULT_VALUE);
                        }

                        self.groupByConfig.selectedOption(GROUPBY_NONE_VALUE);
                    }


                    self.groupByConfig.visible(false);
                    self.trendConfig.visible(false);
                    self.filtersConfig.visible(false);

                    self.metricConfig.visible(true);
                    self.metricConfig.selectedOption(null);
                    self.aggregationConfig.visible(!(self.analysisConfig.selectedOption() === TREND_TYPE.id && (selectedValue === ALL_MODELS.id && selectedCategory !== TRUNK_CATEGORY)));

                } else {
                    self.modelConfig.selectedOption(nonSelectedText);
                }
            },
            visible: ko.observable(false)
        };
    },

    getMetricConfig: function () {
        var self = this;
        const nonSelectedText = '(select metric)';
        return {
            id: 'metric',
            label: 'Metric:',
            availableOptions: ko.observableArray(null),
            selectedOption: ko.observable(),
            nonSelectedText: nonSelectedText,
            onUpdate: function () {
                var selectedValue = ko.unwrap(self.metricConfig.selectedOption);
                if (selectedValue && selectedValue !== nonSelectedText) {
                    self.selectedOptions.metricId = selectedValue;
                    self.selectedMetricMetadata =
                        _.find(_.get(self.selectedModelMetadata, 'metrics'), function (metric) {
                            // todo this should not be set here, but looked up dynamically in panel
                            self.selectedOptions.qualityCategory = metric.category;
                            return metric.id === selectedValue;
                        });

                    if (!self.isFirstSetup) {
                        // clear filter and group by
                        let filterExpression = self.filterModel.getActiveFilters();
                        // remove everything except the auto filter in the first expression
                        if (filterExpression.filterGroups && filterExpression.filterGroups.length > 0) {
                            let filters = filterExpression.filterGroups[0].filters;

                            if (self.selectedCategoryMetadata.modelFilter) {
                                _.remove(filters,  function (f) {
                                    return !(f.auto && f.field === self.selectedCategoryMetadata.modelFilter && f.operatorValue === '=in=(|)');
                                });

                                filterExpression.filterGroups = filterExpression.filterGroups.slice(0,1);

                                self.filterModel.setActiveFilters(filterExpression);
                            } else {
                                self.filterModel.setActiveFilters({filterGroups: [{filters: [], operator: 'and'}], operator: 'and'});
                            }
                        } else {
                            self.filterModel.setActiveFilters({filterGroups: [{filters: [], operator: 'and'}], operator: 'and'});
                        }

                        self.groupByConfig.selectedOption(GROUPBY_NONE_VALUE);
                    }

                    let filterOptionsByMetric = FilterExpressionService.getFilterOptionsForMetric(self.selectedCategoryMetadata.filterOptions, self.selectedMetricMetadata);
                    self.groupByConfig.availableOptions(getGroupByOptions(filterOptionsByMetric));


                    self.filterModel.setAvailableFilters(filterOptionsByMetric);
                    self.filtersConfig.availableOptions(filterOptionsByMetric);

                    if (self.selectedMetricMetadata) {
                        self.titleConfig.selectedOption(self.selectedModelMetadata.name +
                            ' ' +
                            self.selectedMetricMetadata.name
                        );
                    }

                    self.groupByConfig.visible(
                        TREND_TYPE.id === ko.unwrap(self.analysisConfig.selectedOption) && // todo remove when kpi supports group by
                        ko.unwrap(self.groupByConfig.availableOptions).length > 0);
                    self.filtersConfig.visible(filterOptionsByMetric && filterOptionsByMetric.length > 0);
                }
            },
            visible: ko.observable(false)
        };
    },

    getGroupByConfig: function () {
        var self = this;
        const nonSelectedText = '(select group by)';
        return {
            id: 'groupBy',
            label: 'Group By:',
            availableOptions: ko.observableArray(null),
            selectedOption: ko.observable(GROUPBY_NONE_VALUE),
            selectConfig: { nonSelectedText: 'Nothing'},
            nonSelectedText: nonSelectedText,
            onUpdate: function () {
                var selectedValue = ko.unwrap(self.groupByConfig.selectedOption);
                if (!_.isNil(selectedValue)) {
                    self.selectedOptions.groupBy = selectedValue;
                }
                self.trendConfig.visible(
                  TREND_TYPE.id === ko.unwrap(self.analysisConfig.selectedOption) &&
                  self.groupByConfig.visible() &&
                  !_.isNil(selectedValue) &&
                  selectedValue.length > 0
                )
            },
            visible: ko.observable(false)
        };
    },

    getTrendConfig: function() {
      let self = this;
      let mode = document.documentElement.classList.contains('dark') ? 'dark':'light';
      return {
        id: 'trendType',
        label: 'Trend Type:',
        availableOptions: ko.observableArray([
          {
            text: TREND_TYPE_DEFAULT.text,
            value: TREND_TYPE_DEFAULT.value,
            imgSrc: 'dist/images/simple-panel-'+mode+'.png'
          },{
            text: TREND_TYPE_STACKED.text,
            value: TREND_TYPE_STACKED.value,
            imgSrc: 'dist/images/stackedarea-panel-'+mode+'.png'
          },{
            text: TREND_TYPE_PERCENT.text,
            value: TREND_TYPE_PERCENT.value,
            imgSrc: 'dist/images/percentstacked-panel-'+mode+'.png'
          }
        ]),
        selectedOption: ko.observable(TREND_TYPE_DEFAULT.value),
        selectedText: ko.observable(TREND_TYPE_DEFAULT.text),
        onUpdate: function() {
          let selectedValue = ko.unwrap(self.trendConfig.selectedOption);
          if (!!selectedValue) {
            self.selectedOptions.trendType = selectedValue;
          }
        },
        onClick: function(selection, event) {
            self.trendConfig.selectedOption(selection.value);
            self.trendConfig.selectedText(selection.text);
        },
        visible: ko.observable(false)
      };
    },

    getAggregationConfig: function () {
        var self = this;
        return {
            id: 'aggregation',
            label: 'Aggregation:',
            availableOptions: ko.observableArray(getDropdownOptions([
                {
                    'id': AGGREGATE_DEFAULT_VALUE,
                    'name': 'Latest'
                },
                {
                    'id': 'average',
                    'name': 'Average'
                },
                {
                    'id': 'max',
                    'name': 'Max'
                },
                {
                    'id': 'min',
                    'name': 'Min'
                },
                {
                    'id': 'sum',
                    'name': 'Sum'
                }
            ])),
            selectedOption: ko.observable(AGGREGATE_DEFAULT_VALUE),
            nonSelectedText: undefined,
            onUpdate: function () {
                var selectedValue = ko.unwrap(self.aggregationConfig.selectedOption);
                if (selectedValue) {
                    self.selectedOptions.aggregateFunction = selectedValue || AGGREGATE_DEFAULT_VALUE;
                }
            },
            visible: ko.observable(false)
        };
    },

    getFiltersConfig: function () {
        var self = this;
        return {
            id: 'filters',
            label: 'Filters:',
            filterModel: self.filterModel,
            filterReadySignal: self.filterReadySignal,
            availableOptions: ko.observable({}),
            visible: ko.observable(false)
        };
    },

    resetPanelModelOptions: function () {
        var self = this;
        if (!self.isFirstSetup) {
            self.modelConfig.selectedOption(null);
            self.metricConfig.selectedOption(null);
            self.groupByConfig.selectedOption(GROUPBY_NONE_VALUE);
            self.trendConfig.selectedOption(TREND_TYPE_DEFAULT.value);
            self.aggregationConfig.selectedOption(AGGREGATE_DEFAULT_VALUE);
            // todo clear filter

            self.modelConfig.availableOptions(null);
            self.metricConfig.availableOptions(null);
            self.groupByConfig.availableOptions(null);
            // todo clear filter options

            self.modelConfig.visible(false);
            self.metricConfig.visible(false);
            self.aggregationConfig.visible(false);
            self.groupByConfig.visible(false);
            self.trendConfig.visible(false);
            self.filtersConfig.visible(false);
        }
    },

    setupComputedsAndSubscriptions: function () {
        var self = this;

        self.isFormReady = ko.pureComputed(function () {
            let hasErrors = false;

            if (self.categoryConfig.selectedOption() === self.categoryConfig.nonSelectedText) {
                hasErrors = true;
            }
            if (self.metricConfig.visible() && self.metricConfig.selectedOption() === self.metricConfig.nonSelectedText) {
                hasErrors = true;
            }
            if (self.modelConfig.visible() && self.modelConfig.selectedOption() === self.modelConfig.nonSelectedText) {
                hasErrors = true;
            }
            return !hasErrors;
        });

        self.subscriptions.title = self.titleConfig.selectedOption.subscribe(function (updatedTitle) {
            var self = this;
            if (!self.isFirstSetup) {
                self.selectedOptions.title = updatedTitle;
            }
        }, self);

        self.subscriptions.analysis =
            self.analysisConfig.selectedOption.subscribe(self.analysisConfig.onUpdate, self);

        self.subscriptions.filters = self.filtersConfig.availableOptions.subscribe(function (updatedFilters) {
            var self = this;
            self.selectedOptions.filters = updatedFilters.activeFilters;
        }, self);

        if (_.isNil(self.subscriptions.aggregation)) {
            self.subscriptions.aggregation =
                self.aggregationConfig.selectedOption.subscribe(self.aggregationConfig.onUpdate);
        }

        if (_.isNil(self.subscriptions.groupBy)) {
            self.subscriptions.groupBy =
                self.groupByConfig.selectedOption.subscribe(self.groupByConfig.onUpdate);
        }

        if (_.isNil(self.subscriptions.trendType)) {
          self.subscriptions.trendType =
            self.trendConfig.selectedOption.subscribe(self.trendConfig.onUpdate);
        }

    },

    restoreSelections: function (selectedOptions) {
        var self = this;

        self.isFirstSetup = true;

        var filters = selectedOptions.filters || { filterGroups: [{ filters: [], operator: 'and' }], operator: 'and' };
        if (_.isArray(filters)) { // convert from new to old model if needed
            filters = this.filterModel.convertOldFilters(filters);
        }

        self.analysisConfig.selectedOption(self.initialAnalysisId);
        self.analysisConfig.onUpdate();

        var categories = self.categoryConfig.availableOptions();
        if (categories.length === 1) {
            self.categoryConfig.selectedOption(_.get(categories, '0.value'));
        }

        var models = self.modelConfig.availableOptions();
        if (models.length === 1) {
            self.modelConfig.selectedOption(null);
        }


        var metrics = self.metricConfig.availableOptions();

        self.analysisConfig.selectedOption(selectedOptions.analysisId);
        self.categoryConfig.selectedOption(selectedOptions.categoryId);
        self.modelConfig.selectedOption(selectedOptions.modelId);
        self.metricConfig.selectedOption(selectedOptions.metricId);
        self.groupByConfig.selectedOption(selectedOptions.groupBy ? selectedOptions.groupBy : GROUPBY_NONE_VALUE);
        self.trendConfig.selectedOption(selectedOptions.trendType ? selectedOptions.trendType : TREND_TYPE_DEFAULT.value);
        self.trendConfig.selectedText(TREND_TYPE_TO_TEXT_MAP[self.trendConfig.selectedOption()]);
        self.aggregationConfig.selectedOption(selectedOptions.aggregateFunction ? selectedOptions.aggregateFunction : AGGREGATE_DEFAULT_VALUE);
        self.titleConfig.selectedOption(selectedOptions.title);

        self.filterModel.setActiveFilters(filters);

        self.isFirstSetup = false;
    },

    dispose: function () {
        var self = this;
        _.forEach(self.subscriptions, function (subscription) {
            subscription.dispose();
        });
    }
};

function getDropdownOptions(options) {
    return _.map(options, function (option) {
        return { text: _.get(option, 'name', option), value: _.get(option, 'id', option) };
    });
}

function getGroupByOptions(options) {
    return _.map(_.filter(options, function(o) { return !_.get(o, 'excludeGroupBy'); }), function (option) {
        return { text: _.get(option, 'name', option), value: _.get(option, 'id', option) };
    });
}

var instance = null;

function KpiAndTrendOptionsModal() {
    if (instance !== null) {
        throw new Error('Cannot instantiate more than one KpiAndTrendOptionsModal. Call KpiAndTrendOptionsModal.getInstance() instead!');
    }
}

KpiAndTrendOptionsModal.prototype = {
    dialog: function(config) {
        return BaseDialog.showModal({
            viewModel: new KpiAndTrendOptionsDialogVM(config),
            template: templateMarkup,
            context: this
        });
    }
};

KpiAndTrendOptionsModal.getInstance = function() {
    if (instance === null) {
        instance = new KpiAndTrendOptionsModal();
    }
    return instance;
};

export default KpiAndTrendOptionsModal.getInstance();
